import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b()),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('email'))
    }, _toDisplayString(_ctx.displayedEmail), 3),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('balance'))
    }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('balance-skeleton'))
          }, null, 2))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(_ctx.b('balance-error'))
            }, _toDisplayString(_ctx.$t("Ошибка")), 3))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.displayedBalance) + " USDT", 1))
    ], 2)
  ], 2)), [
    [_directive_tooltip, _ctx.displayedTooltip]
  ])
}